export default "__VITE_PUBLIC_ASSET__3e794097__"